<template>
  <div>
    <MaterialPage
      @remove="catchEmit"
      :list="library.materials"
      :material-props="{ additional: additionalBool }"
      types
      :filter-folder="filterFolder"
      :filter-text="filterText"
      @setFilterFolder="setFilterFolder"
      @setTextEvent="setTextEvent"
      @change="changeSort"
    />
  </div>
</template>

<script>
import MaterialPage from '@/views/libs/_materialPage'
import getEvents from '@/mixins/getEvents'
import { mapActions, mapState } from 'vuex'

function checkRoute(to, from, next) {
  if (!to.params.additional) {
    next({
      ...to,
      params: {
        ...to.params,
        additional: 'basic',
      },
    })
  } else next()
}

export default {
  name: 'Materials files',
  mixins: [getEvents],
  components: { MaterialPage },
  beforeRouteEnter: checkRoute,
  beforeRouteUpdate: checkRoute,
  data() {
    return {
      sort: null,
      filterFolder: null,
      filterText: null,
    }
  },
  computed: {
    experts() {
      const experts = this.$route.params.experts
      return experts
        ? experts
            .toString()
            .split(',')
            .map((id) => parseInt(id))
        : []
    },
    additionalBool() {
      return this.$route.params.additional === 'additional'
    },
    list() {
      let list = this.library.materials.filter(({ additional, user, events }) => {
        if (additional !== this.additionalBool) {
          return false
        }
        if (this.experts.length) {
          return this.experts.includes(user?.id)
        }
        if (this.eventFilter) {
          return events.some(({ id }) => id === this.eventFilter)
        }
        return true
      })

      return list
    },
    sortName() {
      let sort = this.sort?.sort;
      if(this.sort?.negative) {
        sort = `-${sort}`;
      }

      return sort;
    },
    ...mapState('library', ['library']),
  },
  methods: {
    ...mapActions('library', ['removeLibrary', 'getLibrary']),
    setFilterFolder(value) {
      if(this.filterFolder === value) {
        this.filterFolder = null;
      }
      else {
        this.filterFolder = value;
      }
      this.fetchList();
    },
    setTextEvent(value) {
      this.filterText = value;
      this.fetchList();
    },
    changeSort(e) {
      this.sort = e;
      this.fetchList();
    },
    fetchList() {
      this.getLibrary({
        params: {
          sort: this.sortName,
          'filter[folder]': this.filterFolder,
          'filter[search]': this.filterText,
        }
      });
    },
    catchEmit(e) {
      this.removeLibrary()
    }
  },
}
</script>
